import { Component, ErrorInfo, ReactNode } from 'react';
import appInsightsService from '../../services/appInsights/appInsights.service';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class AppInsightsErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    appInsightsService.trackException(error, {
      componentStack: errorInfo.componentStack || '',
    });
  }

  private handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-gray-50 p-4">
          <div className="text-center">
            <h1 className="mb-2 text-2xl font-semibold text-gray-900">
              Algo salio mal
            </h1>
            <p className="mb-6 text-gray-600">
              Ocurrio un error inesperado. Por favor, intenta recargar la pagina.
            </p>
            <button
              onClick={this.handleReload}
              className="rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700"
            >
              Recargar pagina
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default AppInsightsErrorBoundary;
